module.exports = __webpack_public_path__ + "img/HogHeaven.8badbf2a.png";